export const PeripheralUpdateAtSortFieldName = "peripheral.updated_at";
